<script setup lang="ts">
import findSm from "~/assets/icons/find/find-sm.svg"

/**
 * The nav instant search component is a visually simple "autocomplete" style search
 * that
 */
const {
  state: instantState,
  onInput,
  onFocusInstantSearch,
  onBlurInstantSearch,
  closeInstantSearch,
} = useInstantSearch()
const query = useTemplateRef("query")

watch(() => instantState.value.query, () => onInput())

onMounted(() => setTimeout(() => query.value?.element?.focus(), 100))
</script>

<template>
  <div class="nav-instant-search">
    <div class="w-6 h-6 flex flex-none items-center justify-center">
      <findSm class="w-4.5 h-4.5" />
    </div>
    <interface-content-editable
      ref="query"
      v-model="instantState.query"
      tag="div"
      wrap
      class="nav-instant-query"
      placeholder="Search all your files..."
      contenteditable="plaintext-only"
      @blur="onBlurInstantSearch()"
      @focus="onFocusInstantSearch()"
    />
    <!-- <nav-pill-button inner class="search-right-button">
      <icon-instant-search type="filter" />
    </nav-pill-button> -->
    <nav-pill-button
      inner
      class="search-right-button close-button"
      @click="closeInstantSearch()"
    >
      <icon-action type="cross" size="xs" />
    </nav-pill-button>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.nav-instant-search
  @apply w-100 flex items-center gap-1

.nav-instant-query
  @apply outline-none bg-transparent
  @apply w-full h-full flex-grow-1 -mt-0.5
  @apply caret-$global-blue-primary

.search-right-button
  @apply flex-none
  @apply h-6 w-6 p-0 flex items-center justify-center

.close-button
  &:hover
    @apply bg-$global-steel-accent
</style>
